import React, { Component, Fragment } from "react";
import { Button } from 'semantic-ui-react'
import { Icon, Input } from 'semantic-ui-react'
import { Container } from 'semantic-ui-react';

import { Link, withRouter } from "react-router-dom";
import Routes from "./Routes";

import Menu from './components/Menu';

import "./App.css";

const ETHER_API_PATH = "http://api.etherscan.io/api?module=account&action=txlist"
const ETHER_ADDRESS = "0xddbd2b932c763ba5b1b7ae3b362eac3e8d40121a"
const ETHER_API_KEY = "apikey=GRHRXF34HFU56GE75DEMBPIQTNNH3NFMQR"
const url = `${ETHER_API_PATH}&address=${ETHER_ADDRESS}&startblock=0&endblock=99999999&sort=asc&${ETHER_API_KEY}`

class App extends Component {

  render() {
    return (
      <div className="App">
        <Fragment>
          <Menu />
        </Fragment>
        <Routes/>
      </div>
    );
  }
}

export default withRouter(App);
